import './Contact.css';
import { IconMail } from './Icons';

const CONTACT_INFO = [
  {
    label: 'E-mail Comercial',
    value: 'comercial@trsilvabueno.com.br',
    href: 'mailto:comercial@trsilvabueno.com.br',
  },
  {
    label: 'Telefone / WhatsApp',
    value: '(41) 9 9991-2971',
    href: 'tel:+5541999912971',
  },
  {
    label: 'Endereço',
    value: 'Curitiba — Paraná',
    href: 'https://maps.google.com/?q=Curitiba+PR',
  },
  {
    label: 'CNPJ',
    value: '22.430.496/0001-76',
    href: null,
  },
];

function Contact() {
  return (
    <section id="contato" className="section-padding contact-section" aria-labelledby="contact-title">
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <span className="section-badge">06</span>
            <p className="section-title">Contato</p>
            <h2 id="contact-title" className="section-heading">
              Pronto para otimizar a{' '}
              <span className="text-accent">logística</span> da sua empresa?
            </h2>
            <div className="red-divider" />
            <p className="contact-lead">
              Entre em contato com nossa equipe comercial e descubra como a Tr Silva
              Bueno pode elevar a eficiência do seu transporte e armazenagem.
            </p>

            <a
              href="mailto:comercial@trsilvabueno.com.br"
              className="contact-email-cta"
            >
              <div className="icon-circle">
                <IconMail />
              </div>
              <span>comercial@trsilvabueno.com.br</span>
            </a>

            <div className="contact-actions mt-4">
              <a
                href="https://wa.me/5541999912971?text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20os%20servi%C3%A7os%20da%20Tr%20Silva%20Bueno."
                className="btn btn-primary-custom"
                target="_blank"
                rel="noopener noreferrer"
              >
                Chamar no WhatsApp
              </a>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="contact-visual">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/caminhao1.png`}
                alt="Caminhão Tr Silva Bueno"
                loading="lazy"
              />
            </div>

            <div className="row g-3 mt-2">
              {CONTACT_INFO.map((item) => (
                <div key={item.label} className="col-sm-6">
                  <article className="contact-card h-100">
                    <h3 className="contact-label">{item.label}</h3>
                    {item.href ? (
                      <a
                        href={item.href}
                        className="contact-value"
                        target={item.href.startsWith('http') ? '_blank' : undefined}
                        rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      >
                        {item.value}
                      </a>
                    ) : (
                      <p className="contact-value mb-0">{item.value}</p>
                    )}
                  </article>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
